import PropTypes from "prop-types";
import * as React from "react";
import { Typography } from "../../themeV2";
import css from "./ShopInfo.module.css";

export default function Section({ id, title, action = null, children }) {
  return (
    <section className={css.section} aria-labelledby={`${id}-heading`}>
      <div className={css.sectionHead}>
        <Typography
          variant="label-md"
          as="h3"
          id={`${id}-heading`}
          className={css.sectionTitle}
        >
          {title}
        </Typography>
        {action}
      </div>
      {children}
    </section>
  );
}

Section.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  action: PropTypes.node,
  children: PropTypes.node,
};
